import { IBridge, IProxyBridge } from "@multiweb/reactCore/bridge/api";
import { bridge as proxyBridgeInstance } from "../proxy";

/**
 * Kontroluje, zda instance bridge je proxy varianta.
 * Proxy modul záměrně neexportuje IProxyBridge, aby zvenku vypadal identicky jako prod modul. Jelikož
 * tsconfig v UI.React obsahuje aliasy na proxy variantu, tak by v rámci UI.React byly dostupné i metody z
 * IProxyBridge. A to nejen v testech a stories, ale i v produkčním kódu, což nechceme. Proto se raději
 * provede kontrola zde.
 * @param bridge Instance bridge k ověření, zda se jedná o proxy implementaci.
 */
const verifyProxy = (bridge: IBridge): IProxyBridge => {
    if (bridge instanceof IProxyBridge) {
        return bridge;
    } else {
        throw new Error("Proxy module of bridge does not export bridge compatible with IProxyBridge. This should never happen.");
    }
};

export * from "../actions";
export * from "@multiweb/reactCore/bridge/api";
export const bridge: IProxyBridge = verifyProxy(proxyBridgeInstance);
// pro podporu tvorby vlastních implementací bridge v testech a stories
export * from "../mock";
export * from "../story";
export * from "../strict";
export * from "./utils";
